__turbopack_context__.v({
  "bannerVideo": "Video169-module__1jSCmG__bannerVideo",
  "btnToggleVolumen": "Video169-module__1jSCmG__btnToggleVolumen",
  "buttonBanner": "Video169-module__1jSCmG__buttonBanner",
  "buttonsBanner": "Video169-module__1jSCmG__buttonsBanner",
  "fadeIn": "Video169-module__1jSCmG__fadeIn",
  "infoBanner": "Video169-module__1jSCmG__infoBanner",
  "videoContainer": "Video169-module__1jSCmG__videoContainer",
  "videoPoster": "Video169-module__1jSCmG__videoPoster",
});
